import { ArrowLeft } from "lucide-react";
import { BrandMark } from "./Navbar";

const Section = ({ title, children, testid }) => (
  <section className="mt-12" data-testid={testid}>
    <h2 className="font-display text-2xl font-semibold text-[#3B322A]">{title}</h2>
    <div className="mt-4 space-y-3 text-sm leading-relaxed text-[#5F5647]">{children}</div>
  </section>
);

export default function Legal() {
  return (
    <div className="min-h-screen bg-[#FAF8F4] text-[#3B322A] antialiased">
      <header className="border-b border-[#A87C4F]/20 bg-[#FAF8F4]/90 backdrop-blur-md">
        <div className="mx-auto flex h-[76px] max-w-4xl items-center justify-between px-5 sm:px-8">
          <a href="/" aria-label="EBS Hotels Revenue">
            <BrandMark />
          </a>
          <a
            href="/"
            data-testid="legal-back-link"
            className="btn-outline-gold inline-flex items-center gap-2 rounded-sm px-5 py-2.5 text-[12px] font-semibold uppercase tracking-[0.14em]"
          >
            <ArrowLeft size={15} />
            Retour au site
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-5 py-16 sm:px-8" data-testid="legal-page">
        <p className="eyebrow">Informations réglementaires</p>
        <h1 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-5xl" data-testid="legal-title">
          Mentions Légales <span className="gold-gradient-text italic">& CGV</span>
        </h1>

        <Section title="1. Éditeur du site" testid="legal-editeur">
          <p>
            Le site <strong>www.ebs-hotels-revenue.com</strong> est édité par la société{" "}
            <strong>ABC Consulting 22</strong>, exploitant la marque EBS HOTELS REVENUE.
          </p>
          <p>Forme juridique : OOD — société à responsabilité limitée de droit bulgare [capital social à compléter]</p>
          <p>Siège social : Ulitza Vtora, Orlova Mogila, Bulgarie</p>
          <p>Numéro d'enregistrement (Bulgarie) : [à compléter]</p>
          <p>Directrice de la publication : Valeria Dragneva, gérante.</p>
          <p>
            Contact : valeriadragneva@gmail.com — +33 6 62 80 56 12 — Nice, France.
          </p>
        </Section>

        <Section title="2. Hébergement" testid="legal-hebergement">
          <p>
            Le site est hébergé par Emergent (emergent.sh). Les données sont hébergées au sein de
            l'infrastructure cloud de l'hébergeur.
          </p>
        </Section>

        <Section title="3. Propriété intellectuelle" testid="legal-propriete">
          <p>
            L'ensemble des contenus du site (textes, logo EBS HOTELS REVENUE, photographies,
            charte graphique) est la propriété exclusive d'ABC Consulting 22, sauf mention
            contraire. Toute reproduction ou utilisation sans autorisation écrite est interdite.
          </p>
        </Section>

        <Section title="4. Données personnelles (RGPD)" testid="legal-rgpd">
          <p>
            Les formulaires de contact et de prise de rendez-vous collectent : nom, email,
            téléphone, nom d'établissement, message et créneau souhaité. Ces données servent
            exclusivement à répondre à votre demande et à organiser nos échanges.
          </p>
          <p>
            Elles sont conservées au maximum 24 mois, ne sont ni vendues ni cédées à des tiers,
            et donnent lieu à un email de confirmation automatique.
          </p>
          <p>
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de
            suppression de vos données : écrivez à valeriadragneva@gmail.com.
          </p>
          <p>Le site n'utilise aucun cookie publicitaire ou de pistage tiers.</p>
        </Section>

        <Section title="5. Conditions Générales de Vente (CGV)" testid="legal-cgv">
          <p>
            <strong>Objet.</strong> ABC Consulting 22 fournit des prestations de conseil en
            revenue management hôtelier : audit, pilotage tarifaire, distribution, automatisation
            et formation, à distance ou sur site.
          </p>
          <p>
            <strong>Devis et tarifs.</strong> Les honoraires sont adaptés à la taille et au
            chiffre d'affaires de chaque établissement et font systématiquement l'objet d'un
            devis personnalisé accepté avant tout démarrage de mission.
          </p>
          <p>
            <strong>Sans engagement.</strong> Sauf mention contraire au devis, la collaboration
            est libre : chaque partie peut l'ajuster ou y mettre fin à tout moment, sans pénalité.
          </p>
          <p>
            <strong>Paiement.</strong> Les prestations sont facturées selon les modalités du
            devis. [Délai et moyens de paiement à compléter]
          </p>
          <p>
            <strong>Confidentialité.</strong> L'ensemble des données et documents de l'hôtel
            client reste strictement confidentiel.
          </p>
          <p>
            <strong>Responsabilité.</strong> Les estimations et projections (simulateur, audits)
            sont fournies à titre indicatif et ne constituent pas une garantie de résultat.
          </p>
          <p>
            <strong>Droit applicable.</strong> Les présentes CGV sont soumises au droit bulgare,
            sous réserve des dispositions impératives applicables. [Juridiction compétente à
            compléter]
          </p>
        </Section>

        <p className="mt-14 border-t border-[#A87C4F]/20 pt-6 text-[11px] uppercase tracking-[0.2em] text-[#948678]">
          Dernière mise à jour : octobre 2026 — ABC Consulting 22
        </p>
      </main>
    </div>
  );
}
